export function hideAppLoadingSpinner(): void {
  const appLoaderSpinner = document.getElementById("app_loader_spinner");
  if (appLoaderSpinner) appLoaderSpinner.outerHTML = "";
}
